import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TransferConfirmPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransferConfirmPage";
import Classes, { Account } from "model";
import { useEffect } from "react";
export default function CaptureMabiLoansTransferCompleteNoMessage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const loanAccount = Account.getDefaultBrandedAccountByType("loan");
     
        const { branding } = globalController.state;
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .update([ "transfer", "to" ], loanAccount)
        .update([ "transfer", "paymentOption" ], "Payment Due")
        .update([ "transfer", "schedule" ], "Recurring")
        .update([ "transfer", "frequency" ], "Monthly")
        .update([ "transfer", "duration" ], "No End Date")
        .update([ "transfer", "startDate" ], BCMSDate.init())
        .update([ "transfer", "estimatedDeliveryDate" ], BCMSDate.init())
        .update([ "transfer", "description" ], "Sample")
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(data.transfer))
    .update(["confirmationBanner", "isActive"], false)
    .submit();
     useEffect(() => {
            Util.replaceDOMDataPointValues(branding);
        });
    return <TransferConfirmPage data={ data } ui={ ui } />
}